import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import ProductionHistoryMobile from "./ProductionHistoryMobile";
import ProductionHistory from "./ProductionHistory";

export default function ResponsiveProductionHistory(props) {
  return useIsMobile() ? <ProductionHistoryMobile {...props} /> : <ProductionHistory {...props} />;
}
